import {
  useGPTModalStore,
  useInteractObjectStore,
  useSpaceObjectStore
} from "@graphic/stores";
import { CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer";

class DetailLabel extends CSS2DObject {
  status: "expand" | "collapse";
  constructor(
    name: string,
    position: "left" | "right",
    color: string,
    opacity: number,
    noradId: number,
    defaultLabel: string
  ) {
    const wrapper = document.createElement("div");
    wrapper.className = "label-wrapper";

    const container = document.createElement("div");
    container.className = "label-container-focused";
    container.style.bottom = "30px";
    if (position === "right") {
      container.style.left = "20px";
      container.style.setProperty("--p", "0%");
      container.style.setProperty("--x", "-20px");
    } else {
      container.style.right = "20px";
      container.style.setProperty("--p", "100%");
      container.style.setProperty("--x", "20px");
    }
    container.style.setProperty("--c", color);

    const header = document.createElement("div");
    header.className = "label-header";
    header.style.display = "flex";
    header.style.flexDirection = "row";
    header.style.alignItems = "center";

    const objectName = document.createElement("div");
    objectName.className = "label-object-name";
    objectName.textContent = name;
    objectName.style.color = "white";
    objectName.style.fontSize = "14px";
    objectName.style.whiteSpace = "nowrap";

    const labelGPTIcon = document.createElement("picture");
    labelGPTIcon.className = "label-gpt-icon";
    labelGPTIcon.style.width = "12px";
    labelGPTIcon.style.height = "12px";
    labelGPTIcon.style.marginLeft = "5px";
    labelGPTIcon.style.paddingBottom = "2px";
    labelGPTIcon.style.cursor = "pointer";

    labelGPTIcon.onclick = e => {
      e.stopPropagation();
      e.preventDefault();
      this.handleClickGPTIcon(String(noradId), name);
    };

    const labelIconImg = document.createElement("img");
    labelIconImg.src =
      color === "#FFA500"
        ? "/svg/gpt-search-icon-white.svg"
        : "/svg/gpt-search-icon.svg";
    labelIconImg.style.width = "100%";
    labelIconImg.style.height = "100%";

    const labelFocusIcon = document.createElement("picture");
    labelFocusIcon.className = "label-gpt-icon";
    labelFocusIcon.style.width = "12px";
    labelFocusIcon.style.height = "12px";
    labelFocusIcon.style.marginLeft = "5px";
    labelFocusIcon.style.paddingBottom = "2px";
    labelFocusIcon.style.cursor = "pointer";

    labelFocusIcon.onclick = e => {
      e.stopPropagation();
      e.preventDefault();
      // handleClickGPTIcon(String(noradId), name);
      this.handleClickFocusIcon(noradId);
    };

    const labelFocusImg = document.createElement("img");
    labelFocusImg.src = "/svg/focus-icon-white.svg";
    labelFocusImg.style.width = "100%";
    labelFocusImg.style.height = "100%";

    const labelExpandIcon = document.createElement("picture");
    labelExpandIcon.className = "label-expand-icon";
    labelExpandIcon.style.width = "12px";
    labelExpandIcon.style.height = "12px";
    labelExpandIcon.style.marginLeft = "5px";
    labelExpandIcon.style.paddingBottom = "2px";
    labelExpandIcon.style.cursor = "pointer";

    labelExpandIcon.onclick = e => {
      e.stopPropagation();
      e.preventDefault();
      // handleClickGPTIcon(String(noradId), name);
      this.handleClickExpandIcon();
    };

    const labelExpandImg = document.createElement("img");
    labelExpandImg.className = "label-expand-icon-img";

    labelExpandImg.src = "/svg/chevron-up-solid.svg";
    labelExpandImg.style.width = "100%";
    labelExpandImg.style.height = "100%";
    labelExpandImg.style.color = "white";

    const body = document.createElement("div");
    body.className = "label-body";
    body.style.display = "flex";
    body.style.flexDirection = "column";

    const bodyText = document.createElement("p");
    bodyText.className = "label-content";
    bodyText.style.color = "white";
    bodyText.style.fontSize = "12px";
    bodyText.style.whiteSpace = "pre";

    labelGPTIcon.appendChild(labelIconImg);
    labelFocusIcon.appendChild(labelFocusImg);
    labelExpandIcon.appendChild(labelExpandImg);

    header.appendChild(objectName);
    // header.appendChild(labelGPTIcon);
    // header.appendChild(labelFocusIcon);
    header.appendChild(labelExpandIcon);

    body.appendChild(bodyText);

    container.appendChild(header);
    container.appendChild(body);

    wrapper.appendChild(container);

    super(wrapper);
    this.status = defaultLabel as "expand" |"collapse";
  }

  handleClickGPTIcon(noradId: string, name: string) {
    const setGPTModal = useGPTModalStore.getState().setGPTModal;
    setGPTModal(noradId, name);
  }

  handleClickFocusIcon(noradId: number) {
    const find = useSpaceObjectStore.getState().find;
    const object = find(noradId);
    const setTracking = useInteractObjectStore.getState().setFocus;
    setTracking(object);
  }

  handleClickExpandIcon() {
    const expandIcon = this.element.querySelector(".label-expand-icon-img");
    if (this.status === "collapse") {
      expandIcon.setAttribute("src", "/svg/chevron-up-solid.svg");
      this.status = "expand";
    } else {
      expandIcon.setAttribute("src", "/svg/chevron-down-solid.svg");
      this.status = "collapse";
      this.setBodyText(null);
    }
  }

  setBodyText(text: string) {
    const bodyText = this.element.querySelector(".label-content");
    bodyText.textContent = text;
  }
}

export default DetailLabel;
